var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "meal-detail" },
    [
      _vm.images.length > 0
        ? _c(
            "div",
            { staticClass: "swipe-warp" },
            [
              _c(
                "swipe",
                { attrs: { autoplay: 3000 } },
                _vm._l(_vm.images, function (item, index) {
                  return _c("swipe-item", { key: index }, [
                    _c("img", {
                      staticClass: "slide-image",
                      attrs: { src: item },
                    }),
                  ])
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "meal-info" }, [
        _c("h3", { staticClass: "meal-name" }, [
          _vm._v(_vm._s(_vm.info.goodsName)),
        ]),
        _c(
          "div",
          { staticClass: "product-info" },
          _vm._l(_vm.info.goodsSettingVoList, function (item, index) {
            return _c("div", { key: index, staticClass: "product-item" }, [
              _c(
                "div",
                { staticClass: "product-content" },
                [
                  _c("van-image", {
                    staticClass: "product-image",
                    attrs: {
                      fit: "cover",
                      src: item.goodsIcon,
                      alt: item.goodsName,
                    },
                  }),
                  _c("span", { staticClass: "product-name" }, [
                    _vm._v(_vm._s(item.goodsName)),
                  ]),
                ],
                1
              ),
              _c("span", { staticClass: "product-num" }, [
                _c("span", { staticClass: "num-tip" }, [_vm._v("数量：")]),
                _vm._v(_vm._s(item.mealNum)),
              ]),
            ])
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "info-list" },
        [
          _c(
            "cell-group",
            [
              _c("cell", {
                attrs: {
                  title: "分类",
                  value: _vm.packageTypeAll.getValueByKey(_vm.info.goodsType),
                },
              }),
              _c("cell", {
                attrs: { title: "规格", value: _vm.info.goodsSpec },
              }),
              _c("cell", {
                attrs: { title: "单位", value: _vm.info.goodsUnit },
              }),
              _c("cell", {
                attrs: { title: "用途", value: _vm.info.goodsFunction },
              }),
              _c("cell", {
                attrs: { title: "描述", value: _vm.info.goodsDesc },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "img-list-box" },
        _vm._l(_vm.images, function (item, index) {
          return _c("img", {
            key: index,
            staticClass: "img-item",
            staticStyle: { width: "100%" },
            attrs: { src: item, mode: "widthFix" },
          })
        }),
        0
      ),
      _c(
        "goods-action",
        [
          _c("goods-action-icon", {
            attrs: { icon: "revoke", text: "返回" },
            on: { click: _vm.goBack },
          }),
          _c("goods-action-icon", {
            attrs: { icon: "chat-o", text: "客服" },
            on: { click: _vm.goTel },
          }),
          _c("goods-action-button", {
            attrs: { type: "danger", text: "立即购买" },
            on: { click: _vm.goBuy },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }